import { Severity } from '../../../../../common/enums/Severity';

export class Issue {
  constructor(
    private readonly number: number,
    private readonly title: string,
    private readonly shortExplanation: string | null,
    private readonly severity: Severity
  ) {}

  getNumber() {
    return this.number;
  }

  getShortExplanation() {
    return this.shortExplanation;
  }

  getTitle() {
    return this.title;
  }

  getSeverity() {
    return this.severity;
  }
}
